<template>
  <div  class="custom-dialog">
    <div class="dialog-overlay"></div>
    <div class="dialog-content">

      <div class="dialog-footer">
        <button @click="close">确定</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    close: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
    }
  }

})
export default class CustomGuangDongDialog extends Vue {
}
</script>

<style scoped lang="scss">
.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  .dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog-content {
    position: relative;
    background-image: url("../assets/guangdong/toast.png");
    background-size: 100% 100%;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    max-width: 300px;
    max-height: 300px;
    width: 90%;
    height: 100%;
    padding: 20px;
    z-index: 10000;

    .dialog-footer {
      display: flex;
      justify-content: center;
      margin-top: 90%;

      button {
        margin-left: 10px;
        padding: 0px 30px;
        border: 5px solid #deab47;
        border-radius: 30px;
        background-color: #fc115a;
        color: white;
        cursor: pointer;
        font-size: 16px;

      }
    }
  }
}
</style>
